<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<!--<div
  class="view-with-static-right-sidebar ps"
  [ngClass]="{ 'sidebar-opened': activitiesService.isOpened }"
  [perfectScrollbar]
>-->

<ng-scrollbar
  class="hotel-view-wrapper relative view-with-static-right-sidebar ps container"
  [ngClass]="{ 'sidebar-opened': activitiesService.isOpened }"
  orientation="vertical"
  #perfectScroll
>
  <div class="top">
    <app-side-button
      [icon]="'far fa-history'"
      [customClasses]="'btn-activity-floating'"
      (click)="openActivities()"
      *ngIf="!activitiesService.isOpened && hotelId"
    >
      >
    </app-side-button>

    <div class="preview-header d-flex justify-content-between align-items-center">
      <div class="preview-title-wrapper">
        <span class="icon-holder"><i class="far fa-hotel"></i></span>
        <span class="title">{{ hotel?.name }}</span>
        <span class="additional-info">
          <span *ngIf="hotel?.stars">
            {{ hotel?.stars }} <span class="star-ico-wrapper"> <i class="fas fa-star"></i></span> /
          </span>
          <span><app-type-badge [type]="hotel?.type"></app-type-badge></span>
          <span>
            <span class="sub-title ms-1">{{ 'HOTELS.HOTEL_VIEW.IMAGES_COUNT' | translate }}:</span>
            <span class="value">{{ hotel?.gallery_count }}</span>
          </span>

          <span *ngIf="hotel?.rooms_count">
            <span class="sub-title ms-1">{{ 'HOTELS.HOTEL_VIEW.ROOMS_COUNT' | translate }}:</span>
            <span class="value">{{ hotel?.rooms_count }}</span>
          </span>
        </span>
      </div>
      <div class="preview-btns-wrapper d-flex align-items-stretch">
        <app-phone-calls-finder-button class="me-2" [id]="hotelId" [type]="LaravelModels.HOTEL">
        </app-phone-calls-finder-button>

        <app-links-compact-translates
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              []
            )
          "
          class="me-2"
          [data]="hotel"
        >
        </app-links-compact-translates>

        <app-reminder-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              []
            )
          "
          class="me-2"
          [reminderableId]="hotel?.id"
          [reminderableType]="LaravelModels.HOTEL"
        ></app-reminder-button>

        <app-media-library-button
          *ngIf="hotelId && accessService.hasAccess([UserRoleType.IT, UserRoleType.MARKETING], ['media.index'])"
          [ngbTooltip]="'HOTELS.HOTEL_VIEW.UPLOAD_IMAGES' | translate"
          container="body"
          [collectionName]="'gallery'"
          [acceptType]="MediaLibraryAcceptTypes.IMAGES"
          [modelId]="hotelId"
          [modelType]="LaravelModels.HOTEL"
          [btnClass]="'btn btn-warning btn-sm'"
          class="me-2"
        >
        </app-media-library-button>

        <app-media-library-button
          *ngIf="
            hotelId &&
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER
              ],
              ['media.index']
            )
          "
          [ngbTooltip]="'HOTELS.HOTEL_VIEW.UPLOAD_DOCUMENTS' | translate"
          container="body"
          [modelId]="hotelId"
          [modelType]="LaravelModels.HOTEL"
          [collectionName]="'invoices'"
          [acceptType]="MediaLibraryAcceptTypes.ALL"
          [icon]="'fal fa-file'"
          [btnClass]="'btn btn-warning btn-sm'"
          class="me-2"
        ></app-media-library-button>

        <button
          *ngIf="
            hotelId &&
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING
              ],
              ['hotels.show']
            )
          "
          type="button"
          class="btn btn-sm btn-success me-2"
          (click)="edit()"
        >
          {{ 'HOTELS.HOTEL_VIEW.EDIT_HOTEL_BTN' | translate }}
        </button>

        <button
          *ngIf="
            hotelId &&
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.store']
            )
          "
          type="button"
          class="btn btn-sm btn-info"
          (click)="addBooking()"
        >
          {{ 'HOTELS.HOTEL_VIEW.NEW_BOOKING_BTN' | translate }}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="sub-title">{{ 'HOTELS.HOTEL_VIEW.CITY' | translate }}</div>
        <div class="value">
          {{ hotel?.city?.name }},
          <app-country-box [country]="hotel?.city?.country"></app-country-box>
        </div>

        <div class="sub-title ms-1">{{ 'HOTELS.HOTEL_VIEW.ADDRESS' | translate }}</div>
        <div class="value">{{ hotel?.address }}</div>

        <div class="d-flex flex-wrap">
          <div class="section" *ngIf="hotel?.contacts?.length > 0">
            <div class="section-title mt-2 mb-1">{{ 'HOTELS.HOTEL_VIEW.CONTACTS' | translate }}</div>

            <app-contacts-box [contacts]="hotel?.contacts"></app-contacts-box>
          </div>

          <div class="section" *ngIf="hotel?.venues?.length > 0">
            <div class="section-title mt-2 mb-1">{{ 'HOTELS.HOTEL_VIEW.VENUES' | translate }}</div>

            <div *ngFor="let venue of hotel?.venues">
              <div class="d-flex">
                <div class="sub-title mb-0">
                  {{ venue.name }}
                  <button
                    class="btn btn-primary btn-ico"
                    (click)="showVenueDirection(venue)"
                    [ngbTooltip]="'HOTELS.HOTEL_VIEW.VIEW_DIRECTIONS' | translate"
                    container="body"
                  >
                    <i class="fal fa-map-pin"></i>
                  </button>
                </div>
                <div class="value strong mb-0 no-wrap" *ngIf="venue.pivot && venue.pivot.distance">
                  {{ venue.pivot.distance }} {{ 'HOTELS.HOTEL_VIEW.KM' | translate }}
                </div>
              </div>
              <div>{{ venue?.pivot?.note }}</div>
              <hr class="mt-2 mb-2" />
            </div>
          </div>

          <div class="section">
            <div class="section-title mt-2 mb-1">{{ 'HOTELS.HOTEL_VIEW.LOCATION' | translate }}</div>

            <div class="d-flex" *ngIf="hotel?.distance_to_tr_point_name || hotel?.distance_to_tr_point">
              <div class="sub-title">{{ 'HOTELS.HOTEL_VIEW.TR_POINT' | translate }}</div>
              <div class="value">
                {{ hotel?.distance_to_tr_point_name }}
                <span class="strong" *ngIf="hotel?.distance_to_tr_point">
                  / {{ hotel?.distance_to_tr_point }} {{ 'HOTELS.HOTEL_VIEW.KM' | translate }}</span
                >
              </div>
            </div>

            <div class="d-flex" *ngIf="hotel?.distance_to_center">
              <div class="sub-title">{{ 'HOTELS.HOTEL_VIEW.CENTER' | translate }}</div>
              <div class="value">
                <span class="strong">{{ hotel?.distance_to_center }} {{ 'HOTELS.HOTEL_VIEW.KM' | translate }}</span>
              </div>
            </div>

            <div class="d-flex" *ngIf="hotel?.distance_to_airport">
              <div class="sub-title">{{ 'HOTELS.HOTEL_VIEW.AIRPORT' | translate }}</div>
              <div class="value">
                <span class="strong">{{ hotel?.distance_to_airport }} {{ 'HOTELS.HOTEL_VIEW.KM' | translate }}</span>
              </div>
            </div>
          </div>

          <div class="section wide" *ngIf="hotel?.activeContactPersons.length > 0">
            <div class="section-title mt-2 mb-1">{{ 'HOTELS.HOTEL_VIEW.CONTACT_PERSONS' | translate }}</div>

            <div class="d-flex flex-wrap">
              <div *ngFor="let contactPerson of hotel?.activeContactPersons" class="section">
                <div *ngIf="contactPerson?.show">
                  <div class="mb-2">
                    <div class="contact-person-name-wrapper">
                      {{ contactPerson?.title?.value }}
                      <strong class="contact-person-name">
                        {{ contactPerson?.first_name }}
                        {{ contactPerson?.last_name }}
                      </strong>
                      {{ contactPerson?.position }}
                    </div>
                  </div>

                  <div class="d-flex align-items-start" *ngIf="contactPerson.event_group?.name">
                    <div class="sub-title">{{ 'HOTELS.HOTEL_VIEW.EVENT_GROUP' | translate }}</div>
                    <div class="value">
                      {{ contactPerson.event_group.name }}
                    </div>
                  </div>

                  <app-contacts-box [contacts]="contactPerson?.contacts"></app-contacts-box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-3">
            <form id="hotel-view-form" [formGroup]="form" novalidate *ngIf="form">
              <div class="form-group">
                <label>{{ 'HOTELS.HOTEL_VIEW.TRANSPORT_TYPE' | translate }}</label>
                <select
                  class="form-control"
                  formControlName="transport_type"
                  (change)="showVenueDirection(selectedVenue)"
                >
                  <option [value]="'DRIVING'">
                    {{ 'HOTELS.HOTEL_VIEW.BY_CAR' | translate }}
                  </option>
                  <option [value]="'TRANSIT'">
                    {{ 'HOTELS.HOTEL_VIEW.BY_PUBLIC_TRANSPORT' | translate }}
                  </option>
                  <option [value]="'WALKING'">
                    {{ 'HOTELS.HOTEL_VIEW.BY_FOOT' | translate }}
                  </option>
                </select>
              </div>
            </form>
          </div>
          <div class="col-sm-9">
            <div class="d-flex mb-2 mt-4">
              <div class="me-3">
                <strong> <i class="far fa-clock"></i> {{ 'HOTELS.HOTEL_VIEW.TRAVEL_TIME' | translate }}:</strong>
                {{ gMapsResults?.duration && form.valid ? gMapsResults?.duration : '-' }}
              </div>
              <div>
                <strong> <i class="far fa-compass"></i> {{ 'HOTELS.HOTEL_VIEW.TRAVEL_DISTANCE' | translate }}:</strong>
                {{ gMapsResults?.distance && form.valid ? gMapsResults?.distance : '-' }}
              </div>
            </div>
          </div>
        </div>
        <!-- needs to be updated with @angular/google-maps -->
        <google-map
          #GoogleMap
          *ngIf="hotel && hotel?.lat && hotel?.long"
          height="260"
          width="100%"
          [center]="{
            lat: number(hotel?.lat),
            lng: number(hotel?.long),
            }">
          <map-marker
            [position]="{
                lat: number(hotel?.lat),
                lng: number(hotel?.long)}
              "
            [icon]="'assets/map_marker2.png'"
            [title]="hotel.address"
            [options]="{draggable: false }"
          >
            <map-info-window class="agm-infowindow">{{ hotel?.name }}</map-info-window>
          </map-marker>
          <ng-container *ngIf="hotel.venues">
          <map-marker
            *ngFor="let venue of hotel.venues; let i = index"
            [position]="{
               lat: number(venue.lat),
               lng: number(venue.long)}
               "
            [icon]="'assets/map_marker.png'"
            [title]="this.form.value.name"
            [options]="{draggable: false }"
            (mapClick)="clickedMarker(hotel.id)"
          >

            <map-info-window class="agm-infowindow">{{ venue?.name! }}</map-info-window>
          </map-marker>
          </ng-container>
        </google-map>



<!--        -->
<!--        <agm-map-->
<!--          class="agm-map"-->
<!--          [latitude]="number(hotel.lat)"-->
<!--          [longitude]="number(hotel.long)"-->
<!--          [scrollwheel]="false"-->
<!--          [zoom]="15"-->
<!--          [fitBounds]="true"-->
<!--          [fullscreenControl]="true"-->
<!--          *ngIf="hotel && hotel.lat && hotel.long"-->
<!--        >-->
<!--          <agm-marker-->
<!--            [markerDraggable]="false"-->
<!--            [latitude]="number(hotel.lat)"-->
<!--            [longitude]="number(hotel.long)"-->
<!--            [agmFitBounds]="true"-->
<!--            [iconUrl]="'assets/map_marker2.png'"-->
<!--          >-->
<!--            <agm-info-window>-->
<!--              <div class="agm-infowindow">{{ hotel.name }}</div>-->
<!--            </agm-info-window>-->
<!--          </agm-marker>-->

<!--          <agm-marker-->
<!--            *ngFor="let venue of hotel?.venues"-->
<!--            [markerDraggable]="false"-->
<!--            [latitude]="number(venue.lat)"-->
<!--            [longitude]="number(venue.long)"-->
<!--            [iconUrl]="'assets/map_marker.png'"-->
<!--            [agmFitBounds]="true"-->
<!--            (markerClick)="clickedMarker(infowindow)"-->
<!--          >-->
<!--            <agm-info-window #infowindow>-->
<!--              <div class="agm-infowindow">{{ venue.name }}</div>-->
<!--            </agm-info-window>-->
<!--          </agm-marker>-->
<!--        </agm-map>-->
      </div>
    </div>
  </div>

  <div class="title2 mt-2">
    {{ 'HOTELS.HOTEL_VIEW.HOTEL_BOOKINGS' | translate }}
  </div>

  <kendo-grid
    [data]="hotelBookingsData"
    [pageSize]="hotelBookingsRequestsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="hotelBookingsState?.filter"
    [sort]="hotelBookingsState?.sort"
    [skip]="hotelBookingsState?.skip"
    [pageable]="true"
    (dataStateChange)="hotelBookingsLoadDataTable($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #hotelBookingsGrid
    (excelExport)="onExcelExport($event, 'Hotel_bookings', hotelBookingsGrid)"
  >
    <kendo-grid-column
      [width]="50"
      class="text-center"
      headerClass="text-center"
      title="{{ 'HOTELS.HOTEL_VIEW.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.company.abbreviation"
      title="{{ 'HOTELS.HOTEL_VIEW.COMPANY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.company.abbreviation')"
      [width]="85"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter" [field]="'booking.company_id'"></app-kendo-company-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a
          [routerLink]="['/settings/companies/view']"
          [queryParams]="{ id: dataItem?.booking.company_id }"
          target="_blank"
        >
          {{ dataItem?.booking?.company?.shortName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.events.name"
      title="{{ 'HOTELS.HOTEL_VIEW.EVENTS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.events.name')"
      [sortable]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-select [filter]="filter" [field]="'event_id'"></app-kendo-event-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div *ngFor="let event of dataItem?.booking?.events; let i = index">
          <a [routerLink]="['/events/view']" [queryParams]="{ id: event?.id }">
            {{ event.formattedName }}
          </a>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.property.value"
      title="{{ 'HOTELS.HOTEL_VIEW.PROPERTY' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('booking.property.value')"
      width="110"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select
          [groupType]="'booking_properties'"
          [field]="'booking.property_id'"
          [filter]="filter"
        ></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem?.booking?.property"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.cancellation_terms.value"
      title="{{ 'HOTELS.HOTEL_VIEW.CANCELLATION_TERMS' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('booking.cancellation_terms.value')"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select
          [groupType]="'booking_cancellation_terms'"
          [field]="'booking.cancellation_terms_id'"
          [filter]="filter"
        ></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem?.booking?.cancellation_terms"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.supplier.name"
      title="{{ 'HOTELS.HOTEL_VIEW.SUPPLIER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('booking.supplier.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-supplier-select [filter]="filter" [field]="'booking.supplier_id'"></app-kendo-supplier-select>
      </ng-template>
    </kendo-grid-column>

    <!--    <kendo-grid-column field="channel.value" title="{{ 'HOTELS.HOTEL_VIEW.CHANNEL' | translate }}" filter="numeric">-->
    <!--      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
    <!--        <app-type-badge [type]="dataItem.channel"></app-type-badge>-->
    <!--      </ng-template>-->
    <!--    </kendo-grid-column>-->

    <!--    <kendo-grid-column-->
    <!--      field="commission_percent"-->
    <!--      title="{{ 'HOTELS.HOTEL_VIEW.COMMISSION_PERCENT' | translate }}"-->
    <!--      filter="numeric"-->
    <!--    ></kendo-grid-column>-->

    <kendo-grid-column
      field="ref_number"
      title="{{ 'HOTELS.HOTEL_VIEW.REF_NUMBER' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('ref_number', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="type.value"
      title="{{ 'HOTELS.HOTEL_VIEW.ROOM_TYPE' | translate }}"
      filter="numeric"
      [hidden]="isHiddenColumn('type.value')"
      width="100"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'rooms'" [filter]="filter"></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem?.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="available_rooms"
      filter="numeric"
      title="{{ 'HOTELS.HOTEL_VIEW.ROOMS_COUNT_SHORT' | translate }}"
      [hidden]="isHiddenColumn('available_rooms')"
      width="65"
      [columnMenu]="false"
      format="0"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" operator="gte">
        </kendo-grid-numeric-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="meal_plan.value"
      title="{{ 'HOTELS.HOTEL_VIEW.MEAL_PLAN' | translate }}"
      [hidden]="isHiddenColumn('meal_plan.value')"
      width="65"
      [columnMenu]="false"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select
          [groupType]="'room_meal_plans'"
          [field]="'meal_plan_id'"
          [filter]="filter"
        ></app-kendo-type-select>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem?.meal_plan"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="check_in"
      title="{{ 'HOTELS.HOTEL_VIEW.CHECK_IN' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('check_in')"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.check_in | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="check_out"
      title="{{ 'HOTELS.HOTEL_VIEW.CHECK_OUT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('check_out')"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.check_out | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="net_price_eur_avg"
      filter="numeric"
      title="{{ 'HOTELS.HOTEL_VIEW.NET_PRICE_AVG' | translate }}"
      [hidden]="isHiddenColumn('net_price_eur_avg')"
      width="95"
      [columnMenu]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.net_price_eur_avg | number : '1.2-2' }}
        {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="price_avg"
      filter="numeric"
      title="{{ 'HOTELS.HOTEL_VIEW.PRICE_AVG' | translate }}"
      [hidden]="isHiddenColumn('price_avg')"
      width="95"
      [columnMenu]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.price_avg | number : '1.2-2' }}
        {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="web_price_avg"
      filter="numeric"
      title="{{ 'HOTELS.HOTEL_VIEW.WEB_PRICE_AVG' | translate }}"
      [hidden]="isHiddenColumn('web_price_avg', true)"
      width="95"
      [columnMenu]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem.web_price_avg | number : '1.2-2' }}
        {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.payment_deadline"
      title="{{ 'HOTELS.HOTEL_VIEW.PAYMENT_DEADLINE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('booking.payment_deadline', true)"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.booking?.payment_deadline | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.cancellation_deadline"
      title="{{ 'HOTELS.HOTEL_VIEW.CANCELLATION_DEADLINE' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      [hidden]="isHiddenColumn('booking.cancellation_deadline', true)"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.booking?.cancellation_deadline | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="booking.show_to_web"
      title="{{ 'HOTELS.HOTEL_VIEW.SHOW_TO_WEB' | translate }}"
      filter="boolean"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('booking.show_to_web')"
      width="80"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.booking.show_to_web"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.IT,
                UserRoleType.MARKETING,
                UserRoleType.EXTERNAL_PARTNER_LEAD,
                UserRoleType.EXTERNAL_PARTNER
              ],
              ['hotel_bookings.show']
            )
          "
          class="btn btn-info btn-ico"
          [routerLink]="'/hotel-bookings/view'"
          [queryParams]="{ id: dataItem?.booking?.id }"
          target="_blank"
        >
          <i class="fal fa-eye"></i>
        </a>

        <!--        <app-preview-button-->
        <!--          [link]="['/hotel-bookings/view']" -->
        <!--          [params]="{ id:dataItem?.booking?.id }">-->
        <!--        </app-preview-button>-->

        <app-edit-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.show']
            )
          "
          (click)="hotelBookingsEdit(dataItem?.booking)"
        >
        </app-edit-button>

        <a
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_booking_cancellations.show']
            )
          "
          class="btn btn-warning btn-ico"
          [routerLink]="['/hotel-booking-cancellations/view']"
          [queryParams]="{ booking_id: dataItem?.booking?.id }"
          [ngbTooltip]="'HOTELS.HOTEL_VIEW.CREATE_CANCELLATION' | translate"
          container="body"
        >
          <i class="fal fa-ban"></i>
        </a>

        <app-delete-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER
              ],
              ['hotel_bookings.destroy']
            )
          "
          [swal]="{}"
          (confirm)="hotelBookingsDelete(dataItem)"
        >
        </app-delete-button>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button
        (click)="hotelBookingsLoadDataTable(hotelBookingsState)"
      ></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="hotelBookingsGrid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>

  <div
    *ngIf="
      accessService.hasAccess(
        [UserRoleType.EXTERNAL_PARTNER, UserRoleType.EXTERNAL_PARTNER_LEAD],
        ['sales.offers.item.index'],
        true
      )
    "
  >
    <div class="title2 mt-2">
      {{ 'HOTELS.HOTEL_VIEW.OFFERS' | translate }}
    </div>

    <kendo-grid
      [data]="salesOffersItemsData"
      [pageSize]="salesOffersItemsRequestsResponse?.meta.per_page"
      [sortable]="true"
      [filterable]="true"
      [columnMenu]="true"
      [filter]="salesOffersItemsState?.filter"
      [sort]="salesOffersItemsState?.sort"
      [skip]="salesOffersItemsState?.skip"
      [pageable]="true"
      (dataStateChange)="salesOffersItemsLoadDataTable($event)"
      (columnVisibilityChange)="onVisibilityChange($event, 'offers')"
      #salesOffersItemsGrid
      (excelExport)="onExcelExport($event, 'Offers', salesOffersItemsGrid)"
    >
      <kendo-grid-column
        [width]="50"
        class="text-center"
        headerClass="text-center"
        title="{{ 'HOTELS.HOTEL_VIEW.NUMBER' | translate }}"
      >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{ rowIndex + 1 }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="sale_offer.sale.client.name"
        title="{{ 'HOTELS.HOTEL_VIEW.CLIENT' | translate }}"
        [hidden]="isHiddenColumn('sale_offer.sale.client.name', false, 'offers')"
        filter="text"
      >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <a
            [routerLink]="['/sales/view']"
            [queryParams]="{ id: dataItem?.sale_offer?.sale_id }"
            target="_blank"
            class="btn-link fw-bold"
          >
            {{ dataItem.sale_offer?.sale?.client?.name }}
          </a>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="sale_offer.sale.event.name"
        title="{{ 'HOTELS.HOTEL_VIEW.EVENT' | translate }}"
        [hidden]="isHiddenColumn('sale_offer.sale.event.name', false, 'offers')"
        filter="text"
      >
        <ng-template kendoGridFilterCellTemplate let-filter>
          <app-kendo-event-select [filter]="filter" [field]="'sale_offer.sale.event_id'"></app-kendo-event-select>
        </ng-template>

        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <a [routerLink]="['/events/view']" [queryParams]="{ id: dataItem?.sale_offer?.sale?.event?.id }">
            {{ dataItem?.sale_offer?.sale?.event?.name }} -
            {{ dataItem?.sale_offer?.sale?.event?.date_from | date : 'yyyy' }}
          </a>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="sale_offer.name"
        title="{{ 'HOTELS.HOTEL_VIEW.OFFER_NAME' | translate }}"
        [hidden]="isHiddenColumn('sale_offer.name', true, 'offers')"
      ></kendo-grid-column>

      <kendo-grid-column
        field="allotment.booking.property.value"
        title="{{ 'HOTELS.HOTEL_VIEW.PROPERTY' | translate }}"
        [hidden]="isHiddenColumn('allotment.booking.property.value', false, 'offers')"
        filter="text"
      >
        <ng-template kendoGridFilterCellTemplate let-filter>
          <app-kendo-type-select
            [groupType]="'booking_properties'"
            [field]="'allotment.booking.property_id'"
            [filter]="filter"
          ></app-kendo-type-select>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <app-type-badge [type]="dataItem?.allotment?.booking?.property"></app-type-badge>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="check_in"
        title="{{ 'HOTELS.HOTEL_VIEW.CHECK_IN' | translate }}"
        filter="date"
        format="{0:dd/MM/yyyy}"
        [hidden]="isHiddenColumn('check_in', false, 'offers')"
      >
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
        </ng-template>

        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{ dataItem.check_in | date : env.pipeDateFormat }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="nights_count"
        title="{{ 'HOTELS.HOTEL_VIEW.NIGHTS_COUNT' | translate }}"
        [filterable]="false"
        [sortable]="false"
        [hidden]="isHiddenColumn('nights_count', false, 'offers')"
        [width]="80"
      >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{ dataItem.check_out | amDifference : dataItem.check_in : 'days' : true }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="check_out"
        title="{{ 'HOTELS.HOTEL_VIEW.CHECK_OUT' | translate }}"
        filter="date"
        format="{0:dd/MM/yyyy}"
        [hidden]="isHiddenColumn('check_out', false, 'offers')"
      >
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
        </ng-template>

        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{ dataItem.check_out | date : env.pipeDateFormat }}
        </ng-template>
      </kendo-grid-column>

      <!--    <kendo-grid-column-->
      <!--      field="offer_item_ref_number"-->
      <!--      title="{{ 'HOTELS.HOTEL_VIEW.REF_NUMBER' | translate }}"-->
      <!--      filter="text"-->
      <!--      [hidden]="isHiddenColumn('offer_item_ref_number')"-->
      <!--    >-->
      <!--      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">-->
      <!--        {{ dataItem.ref_number }}-->
      <!--      </ng-template>-->
      <!--    </kendo-grid-column>-->

      <!--    <kendo-grid-column-->
      <!--      field="offer_item_booking_company"-->
      <!--      title="{{ 'HOTELS.HOTEL_VIEW.BOOKING_COMPANY' | translate }}"-->
      <!--      filter="text"-->
      <!--      [hidden]="isHiddenColumn('offer_item_booking_company')"-->
      <!--    >-->
      <!--      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"></ng-template>-->
      <!--    </kendo-grid-column>-->

      <kendo-grid-column
        [width]="110"
        field="count"
        filter="numeric"
        title="{{ 'HOTELS.HOTEL_VIEW.ROOMS_COUNT_SHORT' | translate }}"
        [hidden]="isHiddenColumn('count', false, 'offers')"
      >
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" operator="gte">
          </kendo-grid-numeric-filter-cell>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{ dataItem.count }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="type.value"
        title="{{ 'HOTELS.HOTEL_VIEW.ROOM_TYPE' | translate }}"
        [hidden]="isHiddenColumn('type.value', false, 'offers')"
      >
        <ng-template kendoGridFilterCellTemplate let-filter>
          <app-kendo-type-select [groupType]="'rooms'" [filter]="filter" [field]="'type_id'"></app-kendo-type-select>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <app-type-badge [type]="dataItem?.type"></app-type-badge>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="meal_plan.value"
        title="{{ 'HOTELS.HOTEL_VIEW.MEAL_PLAN' | translate }}"
        [hidden]="isHiddenColumn('meal_plan.value', false, 'offers')"
      >
        <ng-template kendoGridFilterCellTemplate let-filter>
          <app-kendo-type-select
            [groupType]="'room_meal_plans'"
            [field]="'meal_plan_id'"
            [filter]="filter"
          ></app-kendo-type-select>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <app-type-badge [type]="dataItem?.meal_plan"></app-type-badge>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="net_price"
        title="{{ 'HOTELS.HOTEL_VIEW.NET_PRICE' | translate }}"
        filter="numeric"
        [hidden]="isHiddenColumn('net_price', false, 'offers')"
      >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <div>
            {{ dataItem.net_price | number : '1.2-2' }}
            <app-currency-box [currency]="dataItem?.net_price_currency"></app-currency-box>
          </div>
          <app-currency-converter [fromCurrency]="dataItem.net_price_currency" [value]="dataItem.net_price">
          </app-currency-converter>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="price"
        title="{{ 'HOTELS.HOTEL_VIEW.PRICE' | translate }}"
        filter="numeric"
        [hidden]="isHiddenColumn('price', false, 'offers')"
      >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{ dataItem.price | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="offer_item_margin"
        title="{{ 'HOTELS.HOTEL_VIEW.MARGIN' | translate }}"
        [filterable]="false"
        [hidden]="isHiddenColumn('offer_item_margin', false, 'offers')"
        [sortable]="false"
      >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          {{
            dataItem.price - CurrenciesAdditionsService.toEUR(dataItem.net_price, dataItem.net_price_currency)
              | number : '1.2-2'
          }}
          {{ 'DEFAULT_CURRENCY' | translate }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="offer_item_commission"
        title="{{ 'HOTELS.HOTEL_VIEW.COMMISSION' | translate }}"
        [filterable]="false"
        [sortable]="false"
        [hidden]="isHiddenColumn('offer_item_commission', true, 'offers')"
      >
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"> coming soon</ng-template>
      </kendo-grid-column>

      <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-input></kendo-pager-input>
        <kendo-pager-info></kendo-pager-info>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
        <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
        <app-kendo-grid-refresh-button
          (click)="salesOffersItemsLoadDataTable(salesOffersItemsState)"
        ></app-kendo-grid-refresh-button>
        <button
          type="button"
          class="btn kendo-export-btn"
          [disabled]="salesOffersItemsGrid.loading"
          kendoGridExcelCommand
        >
          {{ 'EXPORT_TO_EXCEL' | translate }}
        </button>
      </ng-template>

      <kendo-grid-excel></kendo-grid-excel>
    </kendo-grid>
  </div>

  <div class="title2 mt-2">
    {{ 'HOTELS.HOTEL_VIEW.SOLD_CLIENTS' | translate }}
  </div>

  <kendo-grid
    [data]="salesFinalsItemsData"
    [pageSize]="salesFinalsItemsRequestsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="salesFinalsItemsState?.filter"
    [sort]="salesFinalsItemsState?.sort"
    [skip]="salesFinalsItemsState?.skip"
    [pageable]="true"
    (dataStateChange)="salesFinalsItemsLoadDataTable($event)"
    (columnVisibilityChange)="onVisibilityChange($event, 'finals')"
    #salesFinalsItemsGrid
    (excelExport)="onExcelExport($event, 'Finals', salesFinalsItemsGrid)"
  >
    <kendo-grid-column
      [width]="50"
      class="text-center"
      headerClass="text-center"
      title="{{ 'HOTELS.HOTEL_VIEW.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="saleFinal.sale.event.name"
      title="{{ 'HOTELS.HOTEL_VIEW.EVENT' | translate }}"
      [hidden]="isHiddenColumn('saleFinal.sale.event.name', false, 'finals')"
      filter="text"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-select [filter]="filter" [field]="'saleFinal.sale.event_id'"></app-kendo-event-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a
          [routerLink]="['/events/view']"
          [queryParams]="{ id: dataItem?.sale_final?.sale?.event?.id }"
          target="_blank"
        >
          {{ dataItem?.sale_final?.sale?.event?.name }} -
          {{ dataItem?.sale_final?.sale?.event?.date_from | date : 'yyyy' }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="saleFinal.sale.event.eventGroup.name"
      title="{{ 'HOTELS.HOTEL_VIEW.EVENT_GROUP' | translate }}"
      [hidden]="isHiddenColumn('saleFinal.sale.event.eventGroup.name', false, 'finals')"
      filter="text"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-group-select
          [filter]="filter"
          [field]="'saleFinal.sale.event.event_group_id'"
        ></app-kendo-event-group-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a
          [routerLink]="['/event-groups/view']"
          [queryParams]="{ id: dataItem?.sale_final?.sale?.event?.event_group?.id }"
          target="_blank"
        >
          {{ dataItem?.sale_final?.sale?.event?.event_group?.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="saleFinal.sale.client.name"
      filter="text"
      title="{{ 'HOTELS.HOTEL_VIEW.CLIENT_COMPANY' | translate }}"
      [hidden]="isHiddenColumn('saleFinal.sale.client.name', false, 'finals')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-client-select [filter]="filter" [field]="'saleFinal.sale.client_id'"></app-kendo-client-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <a
          [routerLink]="['/sales/view']"
          [queryParams]="{ id: dataItem?.sale_final?.sale_id }"
          target="_blank"
          class="btn-link fw-bold"
        >
          {{ dataItem.sale_final?.sale?.client?.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.BOOKING_OFFICE_SHORT' | translate }}"
      field="hotel_booking_room.booking.company.abbreviation"
      [hidden]="isHiddenColumn('hotel_booking_room.booking.company.abbreviation', false, 'finals')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select
          [filter]="filter"
          field="hotel_booking_room.booking.company_id"
        ></app-kendo-company-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.hotel_booking_room?.booking?.company?.abbreviation }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.SUPPLIER' | translate }}"
      field="hotel_booking_room.booking.supplier.name"
      [hidden]="isHiddenColumn('hotel_booking_room.booking.supplier.name', false, 'finals')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-supplier-select
          [filter]="filter"
          field="hotel_booking_room.booking.supplier_id"
        ></app-kendo-supplier-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.hotel_booking_room?.booking?.supplier?.name }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.TYPE' | translate }}"
      width="80"
      field="hotel_booking_room.type.value"
      [hidden]="isHiddenColumn('hotel_booking_room.type.value', false, 'finals')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select [groupType]="'rooms'" [filter]="filter" [field]="'hotel_booking_room.type_id'">
        </app-kendo-type-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem?.hotel_booking_room?.type"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.MEAL_PLAN_SHORT' | translate }}"
      width="80"
      field="hotel_booking_room.meal_plan.value"
      [hidden]="isHiddenColumn('hotel_booking_room.meal_plan.value', false, 'finals')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select
          [groupType]="'room_meal_plans'"
          [filter]="filter"
          [field]="'hotel_booking_room.meal_plan_id'"
        >
        </app-kendo-type-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem?.hotel_booking_room?.meal_plan"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      headerClass="text-center"
      width="40"
      field="PEOPLE_EXPORT"
      title="{{ 'HOTELS.HOTEL_VIEW.PEOPLE' | translate }}"
      [columnMenu]="false"
      [filterable]="false"
      [sortable]="false"
      [hidden]="isHiddenColumn('PEOPLE_EXPORT', false, 'finals')"
    >
      <ng-template kendoGridHeaderTemplate>
        <i class="fas fa-user"></i>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.sale_offer_item?.people * dataItem.count }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.CLIENT_PRICE' | translate }}"
      width="80"
      field="sale_offer_item.price"
      [columnMenu]="false"
      filter="numeric"
      [hidden]="isHiddenColumn('sale_offer_item.price', false, 'finals')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.sale_offer_item?.price | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.NET_PRICE' | translate }}"
      width="80"
      [filterable]="false"
      [sortable]="false"
      [columnMenu]="false"
      filter="numeric"
      field="NET_PRICE_EXPORT"
      [hidden]="isHiddenColumn('hotel_booking_room.net_price', false, 'finals')"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.hotel_booking_room?.net_price | number : '1.2-2' }} {{ 'DEFAULT_CURRENCY' | translate }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.CHECK_IN' | translate }}"
      field="check_in"
      filter="date"
      format="{0:dd/MM/yyyy}"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.check_in | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.CHECK_OUT' | translate }}"
      field="check_out"
      filter="date"
      format="{0:dd/MM/yyyy}"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ dataItem?.check_out | date : env.pipeDateFormat }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.REF_NUMBER_SHORT' | translate }}"
      field="hotel_booking_room.ref_number"
      filter="text"
    >
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'HOTELS.HOTEL_VIEW.REQUEST_LINE_STATUS' | translate }}"
      field="sale_offer_item.request.status_id"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-type-select
          [groupType]="'sale_request'"
          [filter]="filter"
          [field]="'sale_offer_item.request.status_id'"
        ></app-kendo-type-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-type-badge [type]="dataItem?.sale_offer_item?.sale_request?.status"></app-type-badge>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button
        (click)="salesFinalsItemsLoadDataTable(salesFinalsItemsState)"
      ></app-kendo-grid-refresh-button>
      <button
        type="button"
        class="btn kendo-export-btn"
        [disabled]="salesFinalsItemsGrid.loading"
        kendoGridExcelCommand
      >
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</ng-scrollbar>
